import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
var _excluded = ["tagName", "className", "children"];
import React, { useContext } from 'react';
import { Context } from "./store.js";
import { CODE_PREVIEW_PREFIX } from "./CodePreview.js";
export var Code = /*#__PURE__*/React.forwardRef((props, ref) => {
  var {
      tagName = 'div',
      className,
      children
    } = props,
    htmlProps = _objectWithoutPropertiesLoose(props, _excluded);
  var cls = [CODE_PREVIEW_PREFIX + "-code", className].filter(Boolean).join(' ').trim();
  var store = useContext(Context);
  if (store.collapse) {
    return null;
  }
  var TagName = props.href && typeof tagName === 'string' ? 'a' : tagName;
  var childProps = _extends({}, htmlProps, {
    className: cls,
    ref
  });
  return /*#__PURE__*/React.createElement(TagName, childProps, children);
});
Code.displayName = 'uiw.CodeLayoutCode';